@if (inputElem.labelKey) {
  <p
    [id]="uuid()"
    [ngClass]="inputElem.boldLabel ? 'fw-bold text-secondary' : ''"
    [innerHTML]="inputElem.labelKey | translate: inputElem.labelKeyParams"
    class="mb-2 {{ inputElem.labelCss }}"
  ></p>
}
@if (inputElem?.options) {
  @for (checkbox of inputElem?.options; track checkbox.value) {
    <div [ngClass]="{ 'mb-0': inputElem?.isInline || $last, 'form-check-inline': inputElem?.isInline }" class="form-check">
      <input
        [attr.data-test]="getUniqueId($index)"
        [attr.id]="getUniqueId($index)"
        [checked]="isChecked(checkbox.value)"
        (change)="onCheckboxChange(checkbox.value, $event)"
        [name]="inputElem.name"
        [attr.name]="inputElem.name"
        [value]="checkbox.value"
        [ngClass]="{
          'is-invalid': parentForm.controls[inputElem.name]?.errors && !parentForm.controls[inputElem.name]?.pristine,
          'form-check-readonly': isLoading || inputElem.isReadonly,
        }"
        (click)="isLoading || inputElem.isReadonly ? $event.preventDefault() : null"
        [attr.aria-describedby]="ariaDescribedBy || null"
        class="form-check-input"
        type="checkbox"
      />
      <label
        [attr.data-test]="getUniqueId($index) + '-label'"
        [for]="getUniqueId($index)"
        [innerHTML]="checkbox.text | translate"
        [ngClass]="{ 'mb-1': inputElem?.isInline || $last }"
        class="form-label"
      ></label>
    </div>
  }
} @else {
  <div class="form-check mb-0">
    <input
      [attr.data-test]="'form-input-' + inputElem.name"
      [attr.id]="inputElem.name"
      [formControl]="parentForm.controls[inputElem.name]"
      [ngClass]="{
        'is-invalid': parentForm.controls[inputElem.name].errors && !parentForm.controls[inputElem.name].pristine,
        'form-check-readonly': isLoading || inputElem.isReadonly,
      }"
      class="form-check-input"
      type="checkbox"
      [attr.aria-describedby]="ariaDescribedBy"
      [attr.aria-invalid]="!isValid"
    />
    <div>
      <label
        [attr.data-test]="'form-input-' + inputElem.name + '-label'"
        [for]="inputElem.name"
        [innerHTML]="inputElem.placeholder | translate"
        class="form-check-label mb-0"
      ></label>
    </div>
  </div>
}
